import * as React from "react";
import { cn } from "@/lib/utils";
import { useLang } from "@/context/LangContext";

export const STATUS_MAP = {
    pending: { bg: "#FEF6E9", text: "#B36B00", dot: "#F5A623" },
    confirmed: { bg: "#E8F9F8", text: "#0F807B", dot: "#1BC5BD" },
    rejected: { bg: "#FDECEA", text: "#B71C1C", dot: "#B71C1C" },
    refunded: { bg: "#EEF2F8", text: "#475569", dot: "#64748B" },
    online: { bg: "#DCFCE7", text: "#15803D", dot: "#22C55E" },
    offline: { bg: "#FEE2E2", text: "#B91C1C", dot: "#EF4444" },
    low_stock: { bg: "#FEF3C7", text: "#B45309", dot: "#F59E0B" },
};

export function StatusBadge({ status, className, ...props }) {
    const { t } = useLang();
    const s = STATUS_MAP[status] || STATUS_MAP.pending;
    return (
        <span
            className={cn(
                "inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold select-none",
                className,
            )}
            style={{ backgroundColor: s.bg, color: s.text }}
            {...props}
        >
            <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: s.dot }} />
            {t(`status.${status}`)}
        </span>
    );
}
